import './slopeBadge.scss';

import { FormattedMessage } from 'react-intl';

interface SlopeBadgeProps {
  color: 'green' | 'blue' | 'red' | 'black';
  count: number;
}

const SlopeBadge = ({ color, count }: SlopeBadgeProps) => (
  <section className={`SlopeBadge SlopeBadge-${color}`} aria-labelledby={`slope-${color}`}>
    <i className='elibertyIcon-mountain-skiFlag' aria-hidden='true' />
    <span id={`slope-${color}`}>
      <FormattedMessage id={color} defaultMessage={count + ' ' + color} values={{ count: count }} />
    </span>
  </section>
);

export default SlopeBadge;
